import { useAppDisplayModeContext } from '@archipro-design/aria';

import PaginatedVideosDesktop from './PaginatedVideos.desktop';
import PaginatedVideosMobile from './PaginatedVideos.mobile';
import type { PaginatedVideosProps } from '../../api/list-professional-videos.server';

const PaginatedVideos: React.FC<PaginatedVideosProps> = (props) => {
    const { mobile: isMobile } = useAppDisplayModeContext();

    if (isMobile) {
        return <PaginatedVideosMobile {...props} />;
    }

    return <PaginatedVideosDesktop {...props} />;
};

export default PaginatedVideos;
